import { render } from "./ManualDetail.vue?vue&type=template&id=5626f1d7&scoped=true"
import script from "./ManualDetail.vue?vue&type=script&lang=js"
export * from "./ManualDetail.vue?vue&type=script&lang=js"

import "./ManualDetail.vue?vue&type=style&index=0&id=5626f1d7&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5626f1d7"]])

export default __exports__